module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/.pnpm/echo-loader@0.0.1/node_modules/echo-loader/echo-loader.js!../../../../../node_modules/.pnpm/babel-loader@9.2.1_@babel+core@7.29.7_supports-color@8.1.1__webpack@5.111.1_clean-css@5_d37a7e1c5239f70822cac436c843c057/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[1]!./index.js"));
	}, "versions");
}